<div class="guts-p-full-1 oh">
  <dgx-modal-header
    (dismiss)="activeModal.dismiss()"
    [canCancel]="false"
  ></dgx-modal-header>
  <div
    *ngIf="verifyEmail && isSubmitted"
    class="color-ebony-a61 beta center-text guts-p-h-1"
  >
    <p [innerHtml]="headerSubmitted"></p>
  </div>
  <h1
    *ngIf="!isSubmitted"
    class="h2 m-guts-p-h-0 guts-p-h-1 center-text"
    [innerHtml]="header"
  ></h1>
  <div
    *ngIf="verifyEmail && !isMember && !isSubmitted"
    class="center-text guts-m-v-1 guts-p-h-1"
  >
    <form class="crap m-guts-p-h-2 guts-p-h-4">
      <label
        for="workEmail"
        class="ib guts-m-v-1"
        translate="orgInviteFlowModal_VerifyInstructions"
      ></label>
      <div class="field-group">
        <span class="field-group__input">
          <input
            id="workEmail"
            name="workEmail"
            type="email"
            class="zeta"
            [(ngModel)]="userEmail"
            autocomplete="off"
            [placeholder]="
              'orgInviteFlowModal_VerifyEmailFormat'
                | translate: { verifyEmail: verifyEmail }
            "
            data-dgat="orginviteflowModal-6ab"
          />
        </span>
        <span class="field-group__btn">
          <button
            [disabled]="!userEmail"
            [ngClass]="{ is_disabled: !userEmail, 'btn-primary': userEmail }"
            class="btn guts-p-h-2"
            type="submit"
            (click)="submitEmailVerification()"
            translate="Core_Verify"
            data-dgat="orginviteflowModal-ff8"
          ></button>
        </span>
      </div>
    </form>
  </div>
  <div *ngIf="isSubmitted" class="center-text guts-m-t-half">
    <button
      type="button"
      class="link underline"
      dgxAutofocus
      (click)="isSubmitted = !isSubmitted"
      data-dgat="orginviteflowModal-f68"
    >
      {{ 'orgInviteFlowModal_ResendVerification' | translate }}
    </button>
  </div>
  <div *ngIf="!verifyEmail || isMember" class="center-text">
    <button
      class="btn btn-primary guts-m-t-1-half guts-p-v-1"
      type="button"
      (click)="this.activeModal.dismiss()"
      translate="orgInviteFlowModal_LetsGetStarted"
      data-dgat="orginviteflowModal-bfe"
    ></button>
  </div>
  <section class="border-top guts-m-t-2 guts-p-t-2">
    <h2
      class="h2 guts-m-b-1 center-text"
      translate="orgInviteFlowModal_LearnAsTeam"
    ></h2>
    <div class="grid m-guts-p-t-3 guts-p-t-2">
      <div class="grid__col-4">
        <img
          [src]="groupImage"
          [alt]="'orgInviteFlowModal_GroupConversation' | translate"
          class="grid__cell-img"
        />
      </div>
      <div class="grid__col-sm-8">
        <h3
          class="h3 guts-p-b-1"
          translate="orgInviteFlowModal_GroupConversations"
        ></h3>
        <p class="par">
          {{ 'orgInviteFlowModal_SocialGroupFeed' | translate }}
        </p>
      </div>
    </div>
    <div class="grid m-guts-p-t-3 guts-p-t-2">
      <div class="grid__col-4 l_flex-col-2 m-l_flex-col-1">
        <img
          [src]="learningImage"
          [alt]="'orgInviteFlowModal_PersonalLearning' | translate"
          class="grid__cell-img"
        />
      </div>
      <div class="grid__col-sm-8 l_flex-col-1 m-l_flex-col-2">
        <h3
          class="h3 guts-p-b-1"
          translate="orgInviteFlowModal_PersonalizedLearning"
        ></h3>
        <p class="par">
          {{ 'orgInviteFlowModal_DiscoverContentInfo' | translate }}
        </p>
      </div>
    </div>
    <div class="grid m-guts-p-t-3 guts-p-t-2">
      <div class="grid__col-4 m-guts-p-t-3">
        <img
          [src]="recommendationImage"
          [alt]="'orgInviteFlowModal_Recommendations' | translate"
          class="grid__cell-img"
        />
      </div>
      <div class="grid__col-sm-8">
        <h3 class="h3 guts-p-b-1">
          {{ 'orgInviteFlowModal_Recommendations' | translate }}
        </h3>
        <p class="par">{{ 'orgInviteFlowModal_RecommendInfo' | translate }}</p>
      </div>
    </div>
  </section>
</div>
